import $ from 'jquery';
import EditorElement from './editorelement';
import { attached, getDimensions, transitionend, scrollTo } from '@front/dom';
import { PeekyEmitter } from '@shared/peeky.emitter';
import { sleep } from '@shared/sleep';
import { throttle } from '@shared/throttle';
import { Peeky } from '@front/peeky';
import { URL } from '@front/peeky/peeky.url';
import { Chain } from '@shared/chain';
import pkalert from 'editor/pkalert';

import { Font, Fontpicker } from './fontpicker';
import { Colorpicker } from './colorpicker';

import { loadStripe } from '@stripe/stripe-js/pure';
import { Datepicker } from './datepicker';
import { Stripe } from '@stripe/stripe-js';
import { requestAnimationFramePromise } from '@shared/requestanimationframepromise';
loadStripe.setLoadParameters({ advancedFraudSignals: false });


export type DatagraphElement = {
	entity: string;
	_root?: boolean;
	_id?: string;
	relations?: {
		_id: string;
		param: string;
		master: number;
		order: number;
	}[];
	file?: any;
	data?: { [key: string]: string };
	properties?: { [key: string]: string };
	fetched?: boolean;
	fetchedChildren?: boolean;
	templatecol?: string;
	index?: number;

	// Properties that could be added later
	entityVariant?: string;
	parentSite?: EditorElement;
}

export type Relation = {
	element: EditorElement;
	param: string;
	master: number;
}


type statusMessage = {
	message: string;
	duration?: number;
	done?: boolean;
	timeout?: number;
	index?: number;
}


type editorData = {
	user: {
		_id: string
	};
	userid: string;
	graph: DatagraphElement[];
	collaborator: DatagraphElement[];
	demosites: DatagraphElement[];
	template: {
		[templateName: string]: {
			[entityName: string]: {
				catcharg?: string | string[];
				titleprefix?: string;
				pathprefix?: string | string[] | { "key": string, "fallback": string }[];
				skipsub?: string | string[];
				render?: {
					[templateFragmentName: string]: Function
				}
			}
		}
	};
	fonts: Font[];
	variable: { [key: string]: string };
}


class Editor extends PeekyEmitter {

	$body: JQuery;
	$form: JQuery;

	elementIndexId: { [key: string]: EditorElement };
	elementIndexKey: { [key: string]: EditorElement };

	root: EditorElement;
	_key = 0;

	_graph: DatagraphElement[];
	_currentPath: string;
	private _ready = false;
	private _fetching: { [elementKey: string]: boolean };
	private _fetchQueue: { [elementKey: string]: boolean };
	private _submit: { [key: string]: any };
	private _submitting: { [key: string]: any };
	currentForm: EditorElement;
	private _submittimer: number;
	private _submitfile: { [key: string]: any };
	private _submittingfile: { [key: string]: any };
	private _submitreload: boolean;
	private _submittingreload: boolean;
	private _submitcallback: Function[];
	private _submittingcallback: Function[];

	private _statusHeap: statusMessage[];
	private _uploadTotal = 0;
	private _uploadUploaded = 0;
	private _progressTimer: number;
	fontpicker: Fontpicker;
	unlinkedPreview: boolean;

	constructor(public pk: Peeky, public editorData: editorData, public $container: JQuery) {
		super();

		// Container pointers
		this.$container = $container;
		this.$body = $container.find('#body');
		this.$form = $container.find('#panes');

		//this.entity = content.entity;	// Data about each entity
		this.elementIndexId = {};
		this.elementIndexKey = {};

		let editor = this;
		let content = editorData.user;
		let dataGraph = this._graph = editorData.graph;
		let collaborator = editorData.collaborator;
		let demosites = editorData.demosites || [];

		// Poll for user status	(still logged in? Messages? etc)
		(function () {
			var failed = false;
			function checkStatus() {
				$.ajax('/_pollstatus/').done(function (data) {
					if (!data || !data.m.status) {
						// Could not contact polling-server.
						// Retry once before logging out
						if (!failed) {
							setTimeout(checkStatus, 60);
							failed = true;
						} else {
							editor.loginform();
						}
						return;
					}
					var status = data.m.status;
					if (status.ER_ADMIN_NOTLOGGEDIN) {
						editor.loginform();
						return;
					}
					if (status.ER_ACCOUNT_BOUNCED) {
						editor.emailform(editor.root.data('email'));
					}
					if (status.ER_ACCOUNT_NOTACTIVATED) {
						//Peeky.debug('Account not activated');
					}
					failed = false;
				});
			};
			setInterval(checkStatus, 200000);
		})();

		// Fetch userdata
		if (!content) return;


		if (dataGraph) {

			// Add user's own sites
			this.addGraphContent(dataGraph);
			for (let i=0; i<dataGraph.length; i++) {
				let graphElement = dataGraph[i];
				if (graphElement.entity === 'site') {
					let site = this.elementIndexId[graphElement._id];
					site._ownsite = true;
				}
			}

			// Add demosites
			if (demosites && demosites.length > 0) {
				this.addGraphContent(demosites);
				for (let i=0; i<demosites.length; i++) {
					if (demosites[i]._root) {
						let site = this.root.relate('demosite', false, demosites[i]._id || demosites[i], false);
						site._demosite = true;
					}
				}
			}

			// Add collaborating sites
			if (collaborator && collaborator.length > 0) {
				this.addGraphContent(collaborator);
				for (let i = 0; i < collaborator.length; i++) {
					if (collaborator[i]._root) {
						let site = this.root.relate('collabsite', collaborator[i]._id, false);
						site._collabsite = true;
						site.parentParam = 'collabsite';
						site.parent = editor.root;
					}
				}
			}

		}

		// Mark $container as an element (the root element
		$container.addClass('_kkelement').data('element', editor.root);

		// Initiate all event listeners
		editor.initEvents();

		// Go to current path
		pk.one('postGoTo', function (param) {
			editor.goToUrl(pk.paramToUrl(pk.param()), false);
		});

		editor.on('openedPane', function (e: EditorElement) {
			if (e && e.entity === 'site' && e.parent && e.parent.entity === 'user') {
				if (e.$pane.find('.site.hasResponsiveMode').length > 0) {
					$container.addClass('hasResponsiveMode');
				}
			}
		});
		editor.on('closedPane', function (e) {
			if (e && e.entity === 'site' && e.parent.entity === 'user') {
				$container.removeClass('hasResponsiveMode');
			}
		});

		this.trigger('ready');
		this._ready = true;

		// Initiate dashboard
		(async () => {
			await this.root.bindEvents($container.find('.dashboard'));
		})();
	}

	async ready() {
		if (this._ready) {
			return;
		} else {
			await new Promise((resolve) => {
				this.on('ready', resolve);
			});
		}
	}


	addGraphContent(graph: DatagraphElement[], submit?) {
		let editor = this;
		let data: DatagraphElement;
		let element: EditorElement;
		let elements: EditorElement[] = [];
		let leaf: EditorElement;
		let idArray: string[] = [];

		for (let i=0; i<graph.length; i++) {
			let key: string;
			let _id = graph[i]._id;
			if (!_id) {
				continue;
			}
			element = editor.elementIndexId[_id];
			idArray.push(_id);
			if (element) {
				element.fetched = element.fetched || (graph[i].fetched !== false);
				element.fetchedChildren = element.fetchedChildren || (element.fetched !== false && graph[i].fetchedChildren !== false);
				elements.push(element);
				element._addedRelations = false;
				continue;
			}
			if (!editor.root && graph[i]._root) {
				key = '_editorRoot';
			} else {
				key = editor.getkey();
			}
			element = new EditorElement(key, graph[i], undefined, editor, undefined);
			elements.push(element);

			if (!editor.root && graph[i]._root) {
				editor.root = element;
			}

			editor.elementIndexId[_id] = element;
			editor.elementIndexKey[element.key] = element;
		}

		for (let i=0; i<graph.length; i++) {
			data = graph[i];
			element = editor.elementIndexId[data._id];

			if (!element || element.fetched === false || element._addedRelations === true) {
				continue;
			}
			element._addedRelations = true;

			// Sort by order
			data.relations.sort(function (a, b) {
				if (a.order < b.order) return -1;
				else if (a.order > b.order) return 1;
				return 0;
			});

			let relationIndex = {};
			for (let j=0; j<data.relations.length; j++) {
				leaf = editor.elementIndexId[data.relations[j]._id];
				if (data.relations[j].master > 0 && data.relations[j].param !== '_owner') {
					if (!leaf) {
						// Something wrong has happened, element has a relation to an non-existing element
						continue;
					}
					element.relate(data.relations[j].param, true, leaf, submit || false);
					if (!leaf.parent) {

						leaf.parent = element;
						leaf.originalParent = element;
					}
					if (!leaf.parentParam) {
						leaf.parentParam = data.relations[j].param;
					}
				} else {
					element.relate(data.relations[j].param, leaf, submit || false);
				}
			}

			// TODO: Potentially remove elements that are in current element but not in graph
		}

		// Search all children from root, update parents etc.
		function recurse(element: EditorElement, index?: { [key: string]: boolean }) {
			index = index || {};
			if (!element.parentSite && element.parent && element.parent.entity === 'site') {
				element.parentSite = element.parent;
			}
			if (!element.parentSite && element.parent && element.parent.parentSite) {
				element.parentSite = element.parent.parentSite;
			}

			for (let param in element.related) {
				for (let relation of element.related[param]) {
					let child = relation.element;
					if (index[child.key] || child.parent !== element) {
						return;
					}
					index[child.key] = true;
					recurse(child, index);
				}
			}
		}

		for (let i = 0; i < elements.length; i++) {
			if (graph[i]._root) {
				recurse(elements[i]);
			}
		}

		editor.trigger('fetched', idArray);


		// Merge with current graph
		var oldIndex = {};
		for (let i = 0; i < editor._graph.length; i++) {
			oldIndex[editor._graph[i]._id] = i;
		}
		for (let i = 0; i < graph.length; i++) {
			if (typeof (oldIndex[graph[i]._id]) === 'number') {
				editor._graph[oldIndex[graph[i]._id]] = graph[i];
				//console.log('Update graph element ');
			} else {
				oldIndex[graph[i]._id] = editor._graph.length;
				editor._graph.push(graph[i]);
				//console.log('Push new graph element ' + graph[i].data._id + ' : ' + graph[i].data.title + ' ' + graph[i].data.email);
			}
		}

		return elements;
	}


	addSite(siteKey, graph) {
		let editor = this;
		let graphDataIndex = {}
		let elementIndex = {};
		let roots = [];

		// Populate index to lookup graph data by _id
		$.each(graph, function (i, graphData) {
			graphDataIndex[graphData.data._id || graphData._id] = graphData;
			if (graphData._root) {
				roots.push(i);
			}
		});

		var outerChain = new Chain(pk);

		// Create all elements
		function createElement(graphData, callback) {
			var oldId = graphData._id || graphData.data._id;
			var key = editor.getkey();
			graphData._id = undefined;
			graphData.data._id = undefined;

			console.log('Create element ' + graphData.entity + ' : ' + (graphData.data.title || oldId) + ' key: ' + key);

			let element = new EditorElement(editor.getkey(), graphData, undefined, editor, undefined);
			element.one('dataChange', function check(key) {
				if (key !== '_id') {
					element.one('dataChange', check);
				} else {
					elementIndex[oldId] = element;
					var chain = new Chain(pk);

					// Relate to children,  createElement on demand
					graphData.relations = graphData.relations || [];
					$.each(graphData.relations, function (i, relation) {
						var leafOldId = relation._id;
						var newElement;
						var inverseRelation = false;
						if (!leafOldId && relation.leaf) {
							leafOldId = relation.leaf;
						} else if (!leafOldId && relation.root) {
							leafOldId = relation.root;
							inverseRelation = true;
						}

						// Check relation status, don't create if not master
						//if (relation.master <= 0 || relation.param === '_owner') {
						if (relation.param === '_owner' || relation.param === '_collaborator') {
							return;
						}

						chain.then(function (param, next, stop) {
							if (param.confirm === false) {
								next();
							}
							// Use existing element
							else if (elementIndex[leafOldId]) {
								newElement = elementIndex[leafOldId];
								if (inverseRelation) {
									newElement.relate(relation.param, relation.master > 0, element, true, undefined, relation.order);
								} else {
									element.relate(relation.param, relation.master > 0, newElement, true, undefined, relation.order);
								}
								next();
							}
							// Create element first
							else {
								if (!graphDataIndex[leafOldId]) {
									return next();
								}
								//outerChain.then(function(param, next) {
								chain.then(function (param, next) {
									newElement = createElement(graphDataIndex[leafOldId], function () {
										if (inverseRelation) {
											newElement.relate(relation.param, relation.master > 0, element, true, undefined, relation.order);
										} else {
											element.relate(relation.param, relation.master > 0, newElement, true, undefined, relation.order);
										}
										next();
									});
								});
								next();
							}
						});
					});

					chain.done(function () {

						if (!element.parentSite && element.parent && element.parent.entity === 'site') {
							element.parentSite = element.parent;
						}
						if (!element.parentSite && element.parent && element.parent.parentSite) {
							element.parentSite = element.parent.parentSite;
						}
						if (editor._submitting) {
							editor.one('submitted', function () {
								callback();
							});
						} else {
							callback();
						}
					});
				}
			});
			return element;
		}

		$.each(roots, function (i, index) {
			outerChain.then(function (param, next) {
				var siteElement = createElement(graph[index], function () {
					next();
				});
				editor.root.relate('site', siteElement, true);
				siteElement.parent = editor.root;
				siteElement.parentParam = 'site';
				editor.root.updateUI();
			});
		});

		outerChain.done(function () {
			console.log('All done.');
		})
	}



	goTo(path, param) {
		if (!Array.isArray(path)) path = path.replace(/([^\/]|[\/$])/g, '').split('/').slice(1);
		this.root.goTo(path, undefined, undefined, param);
	}


	goToUrl(url, activate, param?) {

		if (!this.pk.underRoot(url)) return;

		let urlObj = new URL(url);
		let pathString = (urlObj.pathname + urlObj.hashPath.replace('^#!', '')) || '';
		pathString = pathString.replace(/^\//, '').replace(/\/\/+/, '\/').replace(/\/$/, '');
		var pathArray = pathString.split('/');

		if (!pathArray[0]) return;
		pathArray.shift(); 	// Remove /admin/

		// Avoid activation
		if (activate === false) this._currentPath = pathString ? '/' + pathString + '/' : '/';

		return this.root.goTo(pathArray, undefined, undefined, param);
	}



	getkey() {
		this._key = (this._key || 0) + 1;
		return 'pk_' + this._key;
	}


	fetchElement(_id, callback?) {
		var that = this;

		if (Array.isArray(_id)) {
			let callbackCount = 0;
			for (let i = 0; i < _id.length; i++) {
				this.fetchElement(_id[i], function () {
					if (++callbackCount === _id.length) {
						callback();
					}
				});
			}
			return;
		}

		// Execute callback when item has been fetched
		if (callback) {
			that.on('fetched', function checkFetch(_idArray) {
				if (_idArray.indexOf(_id) >= 0) {
					that.off('fetched', checkFetch);
					callback();
				}
			});
		}

		// We're already fetching the item
		if (that._fetching && that._fetching[_id]) {
			// Do nothing
		}
		// We already have a queue, add item (doesn't matter if it's already added)
		else if (that._fetchQueue) {
			that._fetchQueue[_id] = true;
		}
		// Create queue
		else {
			that._fetchQueue = {};
			that._fetchQueue[_id] = true;

			// Fetch datagraph
			setTimeout(function () {
				var _ids = Object.keys(that._fetchQueue);
				that._fetching = that._fetchQueue;
				that._fetchQueue = undefined;
				$.ajax({
					dataType: 'jsonp',
					url: '/_datagraph/',
					type: 'POST',
					data: {
						'_kk.rootIds': _ids.join(','),
						'_kk.maxDepth': 2
					},
					success: function (json) {
						that._fetching = undefined;
						that.addGraphContent(json);
					},
					error: function () {
						that._fetching = undefined;
					}
				});
			}, 0);
		}
	}


	initEvents() {
		// Enable compression
		let that = this;
		let $container = this.$container;


		// Extend an extendable listitem
		$container.on('click immediateClick', '.extendlink', function (e) {
			let $item = $(this).closest('.listItem');
			let animationDuration = 250;
			// Close
			if ($item.is('.isExtended')) {
				$item.removeClass('isExtended');
				let $extended = $item.find('.extended');
				if ($item.is(':visible') && e.type !== 'immediateClick') {
					let $closestScroll = $item.closest('.ps');
					let scrolledDown = $closestScroll.scrollTop();
					if (scrolledDown > 0) {
						let extensionHeight = $extended.height();
						let $paneContainer = $item.closest('.paneContainer, #panes');
						let paneOffset = $paneContainer.offset() || { top: 0, left: 0 };
						let paneHeight = paneOffset.top + $paneContainer.height() - extensionHeight;
						let containerHeight = $closestScroll.height();
						let newScrollTop = Math.max(0, paneHeight - containerHeight + scrolledDown)
						$closestScroll.stop().animate({
							scrollTop: newScrollTop
						}, animationDuration);
					}

					$extended.slideUp(animationDuration);
				} else {
					$extended.hide();
				}
				$item.removeClass('focus');
			}
			// Open
			else {
				let $scrollParent: JQuery<HTMLElement> = $item.closest('.ps');
				let scrollParent = $scrollParent[0];
				$item.addClass('isExtended');
				$item.addClass('focus');
				if ($item.is(':visible') && e.type !== 'immediateClick') {
					$item.find('.extended').slideDown(150);
				} else {
					$item.find('.extended').show();
				}
				// Hide other extended items
				$item.siblings().filter('.isExtended').not($item).find('.extendlink').removeClass('focus').trigger('click');
				// Focus first text-field (if empty)
				$item.find('input:not(:file),textarea').first().each(function () {
					if ($(this).val() === '') $(this).focus();
				});
				// Show item
				$item.slideDown(150, function () {
					updatePerfectScroll($scrollParent);
				});
				// Scroll to focus
				scrollTo({
					scrollContainer: scrollParent,
					scrollElement: $item[0],
					makeVisible: true
				});
			}
		});



		// Toggle delete-confirmation-box
		$container.on('click', '.delete, .deleteconfirm .cancel', function (e) {
			var $item = $(this).closest('.listItem')
				, $icon = $item.find('.delete.sprite')
				, $confirm = $item.find('.deleteconfirm')
				, $body = $('body');

			function hide() {
				$confirm.removeClass('active');
				$icon.removeClass('active');
				$confirm.stop().slideUp(150, function () {
					updatePerfectScroll($confirm.closest('.ps'));
				});
			};

			function show() {
				$confirm.addClass('active');
				$icon.addClass('active');
				$confirm.stop().slideDown(150, function () {
					updatePerfectScroll($confirm.closest('.ps'));
				});

				// Close on body click
				setTimeout(function () {
					$body.one('click', function recurse(e) {
						var $filter = $(e.target).parents().add(e.target);
						if ($filter.filter($confirm).length > 0) return $body.one('click', recurse);
						hide();
						if ($item.is('._delhover')) $item.removeClass('_delhover');
						else $item.removeClass('hover')
					});
				});

				if ($item.is('.hover')) $item.addClass('_delhover');
				else $item.addClass('hover');
			};

			$body.trigger('click');

			if ($confirm.is(':visible')) hide();
			else show();

			e.stopPropagation();
			return false;
		});

		
		$container.on('click', '.flip', function() {
			let $site = $(this).closest('.site');
			if ($site.is('.flipped')) {
				$site.removeClass('flipped');
			} else {
				$site.addClass('flipped');
			}
		});


		// Mouse-press-effect on links
		$container.on('mousedown', '.listItem', function (e) {
			if (e.which !== 1 && e.which !== undefined) return;
			var $that = $(this);
			$that.addClass('pressed');
			$(document).one('mouseup', function (e) {
				$that.removeClass('pressed');
				var $target = $(e.target)
					, clicked = false;

				// Fix buggy click behaviour in chrome / opera (sometimes click isn't triggered after changing margins of click area)
				$target.one('click', function () {
					clicked = true;
				});
				setTimeout(function () {
					if (!clicked) $target.trigger('click');
				});
			});
		});
		// GoTo links
		$container.on('click', '[data-goto]', function () {
			if (!that.currentForm) return;
			that.currentForm.goTo([$(this).data('goto')]);
			// TODO: Create new item support!
		});

		$container.on('click', '[data-creategoto]', function () {
			// Look for related object in param
			let $this = $(this);
			let $parent = $this.closest('._pkelement');
			let parent: EditorElement = $parent.data('element');
			if (!parent) return;

			// Check if child exists
			let data = $this.data('creategoto');
			if (parent.related && parent.related[data.param] && parent.related[data.param].length > 0) {
				let relation = parent.related[data.param][0];
				relation.element.goTo();
			} else {
				let child = parent.relate(data.param, { entity: data.entity, entityVariant: data.entityVariant, properties: data.properties, data: data.data }, true);
				child.goTo();
			}
		});


		// Blur text fields on enter
		$container.on('keyup', 'input.text,input[type=text]', function (e) {
			if (e.keyCode === 13) $(this).blur();
		});


		//Expandable form-groups
		$container.on('click' + ' customclick', '.dropdownlink', function (e, temporary) {
			let $this = $(this);
			let $group = $this.closest('.group');
			let $expandable = $group.find('.dropdown:first');
			let $opensiblings = $group.siblings('.group.dropped');
			let $closestScroll = $group.closest('.ps');

			if ($this.data('working')) return;
			$this.data('working', true);

			$opensiblings.find('.dropdownlink').trigger('click');

			function open() {
				$group.addClass('dropped hover');
				$this.addClass('dropped');
				let height = getDimensions($expandable.css('height', '')).height;
				$expandable.stop().css({
					height: 0,
					opacity: 0
				}).animate({
					opacity: 1,
					height: height
				}, 155, function () {
					$expandable.css({
						display: '',
						height: '',
						opacity: ''
					});
					updatePerfectScroll($closestScroll);
					$this.data('working', false);
				});
				// Close on click outside box
				$(document).one('click', function recurse(e, skip) {
					if (skip) $(document).one('click', recurse);
					if (e.which !== 1) return $(document).one('click', recurse);
					if ($(e.target).parents().add(e.target).filter($group).length > 0) return $(document).one('click', recurse);
					if ($(e.target).parents().add(e.target).filter('#panes').length <= 0) return $(document).one('click', recurse);
					if ($(e.target).is('.close')) return $(document).one('click', recurse);
					close();
				});
			};

			function close(temporary?) {
				// If we've scrolled longer down than the height of the actual pane, scroll back up first
				let animationDuration = 200;
				let scrolledDown = $closestScroll.scrollTop();
				if (scrolledDown > 0) {
					let expandableHeight = $expandable.height();
					let $paneContainer = $expandable.closest('.paneContainer, #panes');
					let paneOffset = $paneContainer.offset() || { top: 0, left: 0 };
					let paneHeight = paneOffset.top + $paneContainer.height() - expandableHeight;
					let containerHeight = $closestScroll.height();
					let newScrollTop = Math.max(0, paneHeight - containerHeight + scrolledDown)
					$closestScroll.stop().animate({
						scrollTop: newScrollTop
					}, animationDuration);
				}

				$expandable.stop().animate({
					opacity: 0,
					height: 0
				}, animationDuration, function () {
					$group.removeClass('dropped hover');
					$this.removeClass('dropped');
					$expandable.css({
						display: '',
						opacity: '',
						height: ''
					});
					updatePerfectScroll($expandable.closest('.ps'));
					if (!temporary) {
						$expandable.find('.listItem.focus .extendlink').trigger('immediateClick');
					}
					$this.data('working', false);
				});
			};

			if ($group.is('.dropped')) close(temporary);
			else open();

			$group.data('close', close);
			$group.data('open', open);

		});


		// Drag&drop
		$container.on('drop', false);
		$container.on('dragover', false);
		$container.on('dragleave', false);
		$container.one('dragenter', "#bodywrap", function enter(e) {
			let counter = 1;
			let subEnter = () => {
				counter++;
			};
			let maybeLeave = () => {
				if (--counter === 0) {
					$container.off('dragenter', "#bodywrap", subEnter);
					$container.off('dragleave', "#bodywrap", maybeLeave);
					$container.off('drop', "#bodywrap", drop);
					$container.one('dragenter', "#bodywrap", enter);
					leave();
				}
			};

			let drop = (e) => {
				//console.log('DROP!');
				//console.log(e);
				//console.log(e.originalEvent.dataTransfer);
				return false;
			};
			let leave = () => {
				//console.log('LEAVE!');
			};
			//console.log('ENTER: ');

			$container.on('dragleave', "#bodywrap", maybeLeave);
			$container.on('dragenter', "#bodywrap", subEnter);
			$container.on('drop', "#bodywrap", drop);
		});


		//Disable text-select on elements
		$container.on('dblclick', '.clickable,.noselect', false);
		$container.on('selectstart', '.clickable,.noselect', false);


		// Checkbox-toggles
		this.on('renderedFormFragment', ($fragment: JQuery, element: EditorElement) => {
			let $checkboxes = $fragment.find('input.checkbox');
			let update = function () {
				var $toggle = $(this).closest('label').find('.toggle')
					, $on = $toggle.filter('.on')
					, $off = $toggle.filter('.off');
				if (this.checked) {
					$on.addClass('focus');
					$off.removeClass('focus');
				}
				else {
					$off.addClass('focus');
					$on.removeClass('focus');
				}
			};
			$checkboxes.each(update);
			$checkboxes.on('change', update);
		});


		// Add focus class for textfield wrappers
		$container.on('focus', '.textfield, .focusfield', function () {
			$(this).addClass('focus');
		});
		$container.on('blur', '.textfield, .focusfield', function () {
			$(this).removeClass('focus');
		});

		// Color pickers
		this.on('renderedFormFragment', async ($fragment: JQuery, element: EditorElement) => {
			// TODO: await element.fetched();
			// Color picker
			let $colorpickers = $fragment.find('input.color:not(._colorpick)').addClass('_colorpick');
			for (let i=0; i<$colorpickers.length; i++) {
				let { Colorpicker } = await import(/* webpackChunkName: "colorpicker" */'./colorpicker');
				let $colorpicker = $($colorpickers[i]);
				let colorpicker = new Colorpicker($colorpicker);
			}
		});

		// Date pickers
		this.on('renderedFormFragment', async ($fragment: JQuery, element: EditorElement) => {
			try {
				await attached($container[0], $fragment[0]);
			} catch(e) {
				return;
			}
			$fragment.find('input.date:not(._datepick)').addClass('_datepick').one('mouseenter', function () {
				let datepicker = new Datepicker($container[0], <HTMLInputElement>this);
			});
		});

		// Enum-toggle (enum/varchar/whatever, template decides the values)
		this.on('renderedFormFragment', ($fragment: JQuery, element: EditorElement) => {
			$fragment.find('input.enum').each(function () {
				var $that = $(this);
				var values = $that.data('values') || '';
				var labels = $that.data('labels');
				var $label = $that.closest('label');
				var value = $that.val();
				var defaultValue = $that.attr('placeholder') || $that.data('default');
				var $focusToggle: JQuery;
				if ($that.data('_created')) return;
				$that.data('_created', true);

				values = values.split(',');
				labels = labels ? labels.split(',') : values;
				if ((typeof (value) === 'undefined' || value === '') && typeof (defaultValue) !== 'undefined') {
					value = defaultValue.toString();
				}

				$that.hide();
				$.each(values, function (index, innervalue) {
					var $toggle = $('<span class="toggle toggle_' + innervalue + '" data-value="' + innervalue + '">' + labels[index] + '</span>');
					$label.append($toggle);
					if (value === innervalue || !$focusToggle) $focusToggle = $toggle;
				});
				$focusToggle.addClass('focus');

				$label.on('click', '.toggle', function () {
					$that.val($(this).data('value')).change();
				});

				$that.on('change valNoFocus placeholder', function () {
					value = $that.val();
					defaultValue = $that.attr('placeholder') || $that.data('default');
					if (typeof (value) === 'undefined' || value === '') {
						value = defaultValue;
					}
					$label.find('.toggle.focus').removeClass('focus');
					$label.find('.toggle_' + value).addClass('focus');
				});
			});
		});


		// Add reset buttons to certain fields
		this.on('renderedFormFragment', ($fragment: JQuery, element: EditorElement) => {
			let $inputs = $fragment.find('input.color, input.font');
			let update = function (this: HTMLElement) {
				var $input = $(this);
				var $parent = $input.parent();
				var $reset = $input.data('$reset');
				var placeholder = $input.attr('placeholder');
				var value = $input.val();
				if (placeholder && (value || value == '0')) {
					// Should display reset
					if (!$parent.is('.canReset')) {
						$parent.addClass('canReset');
						if (!$reset) {
							$reset = $('<div class="reset" alt="Reset to default value"></div>');
							$input.data('$reset', $reset);
						}
						$input.after($reset);
					}
				} else {
					if ($parent.is('.canReset')) {
						$parent.removeClass('canReset');
						if ($reset) {	// Should always be true
							$reset.detach();
						}
					}
				}
			};
			$inputs.each(update);
			$inputs.on('change valNoFocus ready', 'input.color, input.font', throttle(update));
		});

		$container.on('click', '.canReset .reset', function () {
			var $container = $(this).closest('.canReset');
			var $input = $container.find('input');
			setValNoFocus($input, '');
			setTimeout(function () {
				$input.change();
			}, 0);
			return false;
		});

		// Text fields with postfix attribute
		this.on('renderedFormFragment', async ($fragment: JQuery, element: EditorElement) => {
			try {
				await attached($container[0], $fragment[0]);
			} catch(e) {
				return;
			}

			let $inputs = $fragment.find('input[data-postfix]');
			$inputs.each(function () {
				let $input = $(this);
				if ($input.data('$postfixContainer')) {
					return; // Already initialized
				}
				let $postfixContainer = $('<div></div>');
				let $postfixValue = $('<span></span>');
				let $postfix = $('<span></span>');
				let postfix = $input.data('postfix');
				$postfix.html(' ' + postfix);
				$input[0].style.padding
				$postfixContainer.css({
					fontFamily: $input.css('font-family'),
					fontWeight: $input.css('font-weight'),
					fontSize: $input.css('font-size'),
					letterSpacing: $input.css('letter-spacing'),
					lineHeight: $input.css('line-height'),
					paddingTop: $input.css('paddingTop'),
					paddingLeft: $input.css('paddingLeft'),
					position: 'absolute',
					top: 0,
					bottom: 0,
					left: 0,
					pointerEvents: 'none'
				});
				$postfixContainer.addClass('input');
				$postfixContainer.addClass($input.attr('class'));
				$postfixContainer.append($postfixValue);
				$postfixContainer.append($postfix);
				$postfixValue.css({
					color: 'transparent'
				});

				let $inputWrapper = $('<div></div>');
				$inputWrapper.css({
					position: 'relative',
					display: $input.css('display') === 'block' ? 'block' : 'inline-block'
				});
				$input.wrap($inputWrapper);
				$input.before($postfixContainer);

				$input.data('$postfixContainer', $postfixContainer);
				$input.data('$postfixValue', $postfixValue);
			});
			let update = function (this: HTMLElement) {
				let $input = $(this);
				let $postfixContainer: JQuery = $input.data('$postfixContainer');
				let $postfixValue: JQuery = $input.data('$postfixValue');
				let value = $input.val().toString();
				if (value === '' || typeof (value) === 'undefined') {
					value = $input.attr('placeholder');
				}
				if (value === '' || typeof (value) === 'undefined') {
					$postfixContainer.css('opacity', 0);
				} else {
					$postfixContainer.css('opacity', 0.5);
				}
				$postfixValue.html(value);
			};
			$inputs.each(update);
			$inputs.on('valNoFocus keyup ready', update);
		});


		$container.one('click', 'label.bool', function toggle(e) {
			var $input = $(this).find('input');
			if ($input.val().toString().toLowerCase() === 'false') {
				$input.val('true').change();
			} else {
				$input.val('false').change();
			}
			setTimeout(function () {
				$container.one('click', 'label.bool', toggle);
			}, 0);
		});
		$container.on('change', 'input.bool', function () {
			var $input = $(this);
			var $label = $input.closest('label');
			if ($input.val().toString().toLowerCase() === 'false') {
				$label.removeClass('focus');
			} else {
				$label.addClass('focus');
			}
		});
		this.on('renderedFormFragment', ($fragment: JQuery, element: EditorElement) => {
			$fragment.find('input.bool').trigger('change');
		});


		// Help
		$container.on('click', '.help .open', function () {
			function toggle() {
				var $help = $(this).parent()
					, $text = $help.find('.text');
				if ($help.is('.open')) {
					$help.removeClass('open');
					$text.stop().slideUp(150);
				} else {
					$help.addClass('open');
					$text.stop().slideDown(150);
				}
			};
			toggle.call(this);
			$('.help.open .open').not(this).each(function () {
				toggle.call(this);
			});
		});


		// Popup url
		$container.on('click', '.popupUrl', function () {
			var url = $(this).text();
			window.open(url, '_blank');
		});


		//Automatic height, dynamic textarea
		this.on('renderedFormFragment', ($fragment: JQuery, element: EditorElement) => {
			$fragment.find('textarea.dynamic').each(function (this: HTMLTextAreaElement) {
				this.rows = 3;
				this.style.overflow = 'hidden';
			});
		});
		$container.on('focus', 'textarea.dynamic', function () {
			var $this = $(this)
				, $dummy = $this.data('$dummy')
				, height = $this.outerHeight();

			if (!$dummy) {
				$dummy = $this.clone();
				$dummy.css({
					position: 'absolute',
					top: -9999,
					left: -9999
				});
				$dummy[0].tabindex = -1;
				$this.after($dummy);
				$this.data('$dummy', $dummy);
				$this.css('height', height); // Set a static height
				$this.data('height', height);
			}
		});
		$container.on('blur', 'textarea.dynamic', function () {
			var $this = $(this)
				, $dummy = $this.data('$dummy')
				, dummy
				, timer;
			if (!$dummy) return;
			dummy = $dummy[0];
			// Slide to "small" size
			timer = setTimeout(function () {
				dummy.rows = 3;
				$this.stop().animate({ height: $this.data('height') }, 200);
				$this.removeData('timer');
			}, 500);
			$this.data('timer', timer);
		});
		$container.on('change paste keydown focus', 'textarea.dynamic', function (e) {
			var $this = $(this)
				, $dummy = $this.data('$dummy')
				, timer = $this.data('timer')
				, dummy;
			if (!$dummy) return;
			dummy = $dummy[0];

			if (timer) {
				clearTimeout(timer);
				$this.removeData('timer');
			}

			setTimeout(function () {
				$dummy.val($this.val());
				$dummy.scrollTop(0);
				if (typeof (dummy.rows) !== 'number') dummy.rows = 0;

				// Reduce size
				while (dummy.scrollHeight <= dummy.clientHeight && dummy.rows > 3) {
					dummy.rows--;
				}

				// Increase size
				while (dummy.scrollHeight > dummy.clientHeight) {
					dummy.rows++;
				}

				// Add two rows
				dummy.rows += 2;

				// Animate height
				$this.stop().animate({ height: $dummy.height() }, 200);
			}, 0);
		});


		let prepareCard = async function () {
			var $this = $(this);
			if ($this) {
				let $creditCards = $this.find('.creditCard');
				for (let i=0; i<$creditCards.length; i++) {
					let $form = $($creditCards[0]);
					let $card = $form.find('.cardElement');

					// Set stripe public key
					if (!$container.data('stripe')) {
						let stripe = await loadStripe(that.editorData.variable.stripePublicKey);
						$container.data('stripe', stripe);
					}

					let stripe = $container.data('stripe');
					let elements = stripe.elements();
					let style = {
						base: {
							color: $card.css('color'),
						},
						invalid: {
							iconColor: '#fa755a'
						}
					};
					let card = elements.create('card', { style: style });
					card.mount($card[0]);
					$form.data('card', card);
				}
			}
		};
		$container.on('click', 'button.payment,.button.payment', async function () {
			await that.updateCard($(this).closest('.updateCard'));
		});
		// Prepare credit card forms with Stripe Elements
		$container.one('click', '[data-bind="property.stripeId:payment"]', prepareCard);
		$container.one('click', '.changeSitePlan', prepareCard);


		this.on('localVar', async function(elementKey, variableKey, value) {
			if (variableKey === 'stripePaymentIntentCS') {
				let element = this.elementIndexKey[elementKey];

				// Set stripe public key
				let stripe: Stripe = $container.data('stripe');
				if (!stripe) {
					stripe = await loadStripe(that.editorData.variable.stripePublicKey);
					$container.data('stripe', stripe);
				}
				stripe.handleCardAction(value).then(function (result) {
				//stripe.confirmCardPayment(value).then(function(result) {
					if (result.error) {
						pkalert(result.error.message);
						// If this is a one-off payment, cancel it in the backend
						if (element.data('onSession') == '1') {
							element.submit('cancelPaymentIntent', '1');
							element.submit('entity', element.entity);
							element.submit('_id', element);
						}
					} else {
						element.submit('verifyPaymentIntent', '1');
						element.submit('entity', element.entity);
						element.submit('_id', element);
						element.trigger('paymentSuccess');
					}
				});
			}
			if (variableKey === 'paymentIntentError') {
				pkalert(value);
			}
		});


		// Remove recurring
		$container.on('click', '.paymentUnsubscribe', function () {
			that.root.property('stripeCcLastfour', '', false);
			that.root.property('stripeCcMonth', '', false);
			that.root.property('stripeCcYear', '', false);
			that.submit(that.root.key + '._id', that.root);
			that.submit(that.root.key + '.entity', that.root.entity);
			that.submit(that.root.key + '.insert.stripeUnsubscribe', 'true');
			that.root.updateUI();
		});


		$container.on('click', '.payment .pay', async function () {
			const $listItem = $(this).closest('.listItem');
			const element: EditorElement = $listItem.data('element');
			const paymentIntent = $listItem.data('pi');
			const paymentIntentCS = $listItem.data('cs');

			if ($listItem.is('.submitting')) {
				return;
			}

			if (!that.root.property('stripePaymentMethod')) {
				pkalert('You need to add a credit card to your account. You can do this under "Billing info".');
				return;
			}

			$listItem.addClass('submitting');
			let stripe = $container.data('stripe');
			if (!stripe) {
				stripe = await loadStripe(that.editorData.variable.stripePublicKey);
			}
			let result = await stripe.confirmCardPayment(paymentIntentCS).catch((err) => {
				pkalert(err.message);
			});
			element.submit('entity', element.entity);
			element.submit('_id', element);
			element.submit('preparePayment', 'true');

			await new Promise<void>((resolve) => {
				element.one('paymentSuccess', function () {
					resolve();
				});
			});
			$listItem.removeClass('submitting');
		});


		// Warning mouseover
		$container.on('mouseover', '.warningIcon', function () {
			var $this = $(this)
				, $warning = $this.closest('.warning')
				, $message = $warning.find('.warningMessage');
			$warning.one('mouseleave', function () {
				$message.removeClass('visible');
			});
			$message.addClass('visible');
		});


		// Catch password update clicks
		$container.on('click', 'button.updatePassword', function () {
			var $that = $(this).closest('div.updatePassword')
				, editor = $that.closest('.peekySite').data('editor')
				, $password = $that.find('input.password')
				, $currentPassword = $that.find('input.currentPassword');
			editor.submit(editor.root.key + '._id', editor.root);
			editor.submit(editor.root.key + '.entity', editor.root.entity);
			editor.submit(editor.root.key + '.insert.password', $password.val());
			editor.submit(editor.root.key + '.insert.currentPassword', $currentPassword.val());
			$password.val('');
			$currentPassword.val('');
		});
		$container.on('click', 'button.setPassword', function () {
			var $that = $(this).closest('div.setPassword')
				, editor = $that.closest('.peekySite').data('editor')
				, $password = $that.find('input.password');
			editor.submit(editor.root.key + '._id', editor.root);
			editor.submit(editor.root.key + '.entity', editor.root.entity);
			editor.submit(editor.root.key + '.insert.password', $password.val());
			$password.val('');
		});


		// Catch email update clicks (when mail bounced)
		$container.on('click', 'button.updateEmail', function () {
			var $that = $(this).closest('div.updateEmail')
				, editor = $that.closest('.peekySite').data('editor')
				, $email = $that.find('input.email');
			editor.submit(editor.root.key + '._id', editor.root);
			editor.submit(editor.root.key + '.entity', editor.root.entity);
			editor.submit(editor.root.key + '.insert.email', $email.val());
		});


		// Up/down arrow keys for number fields
		$container.on('keydown', 'input.number', function (e) {
			var $this = $(this);
			var float = $this.is('.float');
			var decimals = $this.data('decimals') || 2;
			var val = $this.val() === '' ? $this.attr('placeholder') || '0' : $this.val() || '0';
			var current = float ? parseFloat(val.toString()) : parseInt(val.toString(), 10);
			var diff = (e.which === 38) ? 1 : (e.which === 40) ? -1 : 0;
			if (isNaN(current)) {
				current = 0;
			}

			if (diff === 0) return;

			setTimeout(function () {
				$this.val(float ? (current + (diff * 0.1)).toFixed(2) : current + diff);
				$this.change();
			});

			return false;
		});

		(function () {

			function getValue(element: EditorElement, property: string) {
				let propertyarray = (property || '').split('.');
				if (propertyarray[0] === 'insert') {
					return element.data(propertyarray[1]);
				} else if (propertyarray[0] === 'property') {
					return element.property(propertyarray[1]);
				}
			};
			function setValue(element: EditorElement, property: string, value: string, reload?: boolean) {
				let propertyarray = (property || '').split('.');
				if (propertyarray[0] === 'insert') {
					element.data(propertyarray[1], value, reload);
				} else if (propertyarray[0] === 'property') {
					element.property(propertyarray[1], value, true, reload);
				}
				element.updateUI();
			};

			$container.on('click', '.settingsDrop', function (e) {
				var $dropButton = $(this);
				e.preventDefault();
				e.stopPropagation();
				if ($dropButton.is('.dropped')) {
					$dropButton.trigger('close');
					return;
				}
				var $element = $dropButton.closest('._pkelement');
				var element: EditorElement = $element.data('element');
				var settings = $dropButton.data('settings');
				var $settingsContainer = $('<div class="settings dropdownField"></div>');
				$.each(settings, function (index, setting) {
					var $setting = $('<div class="setting"></div>');
					if (setting.type === 'delete') {
						$setting.append('<div class="deleteItem"><span class="confirmDeleteLabel">Are you sure?</span> <span class="cancelDelete">Cancel</span> <span class="initDelete">Delete</span></div>');
					}
					if (setting.type === 'toggle') {
						let value = getValue(element, setting.property);
						let valueOn = typeof(setting.valueOn) === 'undefined' ? true : setting.valueOn;
						//var valueOff = typeof(setting.valueOff) === 'undefined' ? false : setting.valueOff;
						if (value === 'true') value = true;
						if (value === 'false') value = false;
						let isOn = value === valueOn;
						$setting.append('<div class="label">' + setting.label + '</div>');
						$setting.append('<div class="toggle' + (isOn ? ' on' : '') + '"><div class="off">' + setting.labelOff + '</div><div class="on">' + setting.labelOn + '</div></div>');


					}
					if (setting.type === 'value') {

					}
					$setting.data('setting', setting);
					$settingsContainer.append($setting);
				});
				$dropButton.addClass('dropped');
				$settingsContainer.css('display', 'none');
				$dropButton.closest('.listHeader').after($settingsContainer);
				$settingsContainer.slideDown(200);
				$element.addClass('hover');
				setTimeout(function () {
					$dropButton.one('close', function () {
						$dropButton.removeClass('dropped');
						$settingsContainer.slideUp(200, function () {
							$settingsContainer.remove();
						});
						$element.removeClass('hover');
					});
					$('body').one('click', function recurse(e) {
						if ($(e.target).parents().addBack().filter($settingsContainer).length > 0) {
							$('body').one('click', recurse);
						} else {
							$dropButton.trigger('close');
						}
					});
				});
			});

			$container.on('click', '.settings .confirmDelete .initDelete', function () {
				var $element = $(this).closest('._pkelement');
				var element: EditorElement = $element.data('element');
				var parent = element.parent;
				element.unrelate(element.parentParam, parent);
				parent.updateUI();
			});
			$container.on('click', '.settings :not(.confirmDelete) .initDelete', function () {
				var $deleteItem = $(this).closest('.deleteItem');
				$deleteItem.addClass('confirmDelete');
			});
			$container.on('click', '.settings .cancelDelete', function () {
				var $deleteItem = $(this).closest('.deleteItem');
				$deleteItem.removeClass('confirmDelete');
			});
			$container.on('click', '.settings .toggle', function () {
				let $toggle = $(this);
				let $setting = $toggle.closest('.setting');
				let setting = $setting.data('setting');
				let $element = $setting.closest('._pkelement');
				let element: EditorElement = $element.data('element');
				let value = getValue(element, setting.property);
				let valueOn = typeof (setting.valueOn) === 'undefined' ? true : setting.valueOn;
				let valueOff = typeof (setting.valueOff) === 'undefined' ? false : setting.valueOff;
				if (value === 'true') value = true;
				if (value === 'false') value = false;
				if (value === valueOn) {
					value = valueOff;
					$toggle.removeClass('on');
				} else {
					value = valueOn;
					$toggle.addClass('on');
				}
				setValue(element, setting.property, '' + value, setting.reload);
			});
		})();


		$container.on('click', '.addItemDropper', async function () {
			var $dropper = $(this);
			var $drop = $dropper.find('.addItemDrop');
			if (!$drop.is('.dropped')) {
				$drop.slideDown(250);
				$dropper.addClass('focus');
				$drop.addClass('dropped');
				$drop.addClass('droppedInit');
				$drop.width();
				$drop.addClass('dropping');
				$drop.removeClass('droppedInit');
				await transitionend($drop[0]);
				$drop.removeClass('dropping');
				$(window).one('click', close);
			}
			async function close(e) {
				$drop.slideUp(250);
				$drop.addClass('undrop');
				$drop.addClass('undropInit');
				$drop.width();
				$drop.addClass('undropping');
				$drop.removeClass('undropInit');
				await transitionend($drop[0]);
				$drop.removeClass('undrop');
				$drop.removeClass('undropping');
				$drop.removeClass('dropped');
				$dropper.removeClass('focus');
			}
		});


		// Filter in dropdown list
		$container.on('keyup change', '.collectionFilter', function () {
			var $this = $(this);
			var value = $this.val().toString();
			var $collection = $this.closest('.collection,.filteredContainer');
			var $items = $collection.find('.listItem:not(.add,.excluded)');
			var $visible = (value !== '') ? $items.filter(function () { return !!$(this).text().match(new RegExp(value, 'i')) }) : $items;
			var $hidden = (value !== '') ? $items.not($visible) : $([]);
			var $remove = $collection.find('._removeFilter');
			$hidden.not('._hidden').addClass('_hidden').stop().slideUp(200);
			$visible.filter('._hidden').removeClass('_hidden').stop().slideDown(200);
			if (value !== '' && $remove.length <= 0) {
				$remove = $('<div class="_removeFilter label clickable">Remove filter</div>');
				$remove.css('display', 'none');
				$this.after($remove);
				$remove.on('click', function () {
					$this.val('');
					$this.trigger('change');
				});
			}
			if (value === '') {
				if ($remove.is('._dropped')) {
					$remove.stop().slideUp(200);
					$remove.removeClass('_dropped');
				}
			} else {
				if (!$remove.is('._dropped')) {
					$remove.stop().slideDown(200);
					$remove.addClass('_dropped');
				}
			}
			$items.off('click.resetFilter');
			$items.on('click.resetFilter', function () {
				$remove.trigger('click');
			});
		});

		// Filter / insert new relation
		$container.on('focus', '.relationSelector', function () {
			$(this).find('.hints').stop().slideDown(200);
		});
		$container.on('blur', '.relationSelector', function () {
			$(this).find('.hints').stop().slideUp(200);
		});
		$container.on('keyup change', '.relationSelector input', function (e) {
			var $this = $(this);
			var value = $this.val().toString();
			var $relationSelector = $this.closest('.relationSelector');
			var $items = $relationSelector.find('.hints .listItem');
			var $visible = (value !== '') ? $items.filter(function () { return !!$(this).text().match(new RegExp(value, 'i')) }) : $items;
			var $hidden = (value !== '') ? $items.not($visible) : $([]);
			var $exactmatch = (value !== '') ? $items.filter(function () { return new RegExp('^' + value + '$', 'i').test($(this).text().trim()); }) : $items;
			var $insertNew = $relationSelector.find('.insertNew');
			if (e.which === 13) {
				$insertNew.trigger('click');
				return;
			}
			$hidden.not('._hidden').addClass('_hidden').stop().slideUp(200);
			$visible.filter('._hidden').removeClass('_hidden').stop().slideDown(200);
			if (value === '' || $exactmatch.length > 0) {
				$insertNew.filter('._visible').slideUp(200).removeClass('_visible');
			} else {
				$insertNew.not('._visible').slideDown(200).addClass('_visible');
			}
		});
		$container.on('click', '.relationSelector .insertNew', function () {
			var $this = $(this);
			var $relationSelector = $this.closest('.relationSelector');
			var $value = $relationSelector.find('input');
			var value = $value.val();
			var $items = $relationSelector.find('.hints .listItem');
			var $exactmatch = (value !== '') ? $items.filter(function () { return new RegExp('^' + value + '$', 'i').test($(this).text().trim()); }) : $items;
			if ($exactmatch.length > 0) {
				var $clicker = $exactmatch.first().find('.listHeader');
				$clicker.click();
			} else {
				// Insert new
				var owner = that.elementIndexKey[$this.data('owner') || $this.data('relate')];
				var ownerParam = $this.data('ownerparam') || $this.data('relateparam');
				var relateTo = that.elementIndexKey[$this.data('relate')];
				var relateParam = $this.data('relateparam');
				var data = {};
				data[$this.data('valueField') || 'title'] = value;
				var newElement = owner.relate(ownerParam, {
					entity: $this.data('entity'),
					entityVariant: $this.data('entityvariant'),
					data: data
				}, true);
				relateTo.relate(relateParam, newElement);
				owner.updateUI();
				relateTo.updateUI();
			}
		});
	}


	//
	//
	submit(param?, value?: string | File | EditorElement, reload?, immediate?, callback?) {
		let that = this;
		let i = 0;
		if (typeof (arguments[i]) !== 'function') param = arguments[i++];
		if (typeof (arguments[i]) !== 'function') value = arguments[i++];
		if (typeof (arguments[i]) !== 'function') reload = arguments[i++];
		if (typeof (arguments[i]) !== 'function') immediate = arguments[i++];
		if (typeof (arguments[i]) === 'function') callback = arguments[i++];

		// This is a submit() call, trigger the actual submit
//console.log('submit ' + param + ' -> ' + value);
		if (arguments.length <= 0) {
			if (!this._submit || this._submitting) return;

			let submitting = this._submitting = this._submit;
			this._submittingfile = this._submitfile;
			this._submittingreload = this._submitreload;
			this._submittingcallback = this._submitcallback;
			if (this._submittimer) {
				clearTimeout(this._submittimer);
				this._submittimer = undefined;
			}
			this._submit = undefined;
			this._submitfile = undefined;
			this._submitreload = undefined;
			this._submitcallback = undefined;

			// Loop all _submitting entries, convert element objects into _ids
			let formData = new FormData();
//console.log(this._submitting);
			for (let index in this._submitting) {
				let value = this._submitting[index];
				// String
				if (typeof(value) === 'string') {
					formData.append(index, value);
				}
				// File input?
				else if (value instanceof File) {
					formData.append(index, value);
				}
				// Get _ID from element
				else if (value instanceof EditorElement) {
					let _id = value.data('_id');
					if (_id) {
						formData.append(index, _id);
					}
				} else {
				}
			}

			// Set status message
			let status = that.status('Saving&hellip;');
			let progress = that.progressInstance();

			// Peeky.debug('Submitting ' + $.param(this._submitting));
			// console.log('Submitting ' + $.param(this._submitting));
			(async function maybeRecurse(secondTry) {
				let xhr = await pk.ajax({
					url: '/_update/',
					method: 'POST',
					formData: formData,
					onProgress: (event) => {
						if (event.total > 100) {
							progress(event.loaded, event.total);
						}
					}
				});

				if (xhr.status !== 200) {
					that.trigger('submitted', xhr);
					if (xhr.status == 503 && !secondTry) {
						// Retry
						maybeRecurse(true);
						return;
					} else if (xhr.status == 413) {
						// Uploading too big a file
						pkalert('The file you are uploading is too big');
					} else {
						console.log('Error: ' + xhr.status);
						console.log(xhr);
					}
					delete (that._submitting);
					delete (that._submittingfile);
					delete (that._submittingreload);
					delete (that._submittingcallback);
					status();
					that.submit();
					return;
				}

				let dataSrc = xhr.responseText;
				let data: any;
				try {
					// CRLF -> LF
					dataSrc = dataSrc.replace(/\\r(\\n)?/gm, '\\n');
					data = JSON.parse(dataSrc);
				} catch(e) {
					// Server side error!
					if (!secondTry) {
						maybeRecurse(true);
					} else {
						console.log('An error occured.');
						console.log(dataSrc);
						console.log(xhr);
					}
					status();
					that.submit();
					return;
				}

				that.trigger('submitted', null, data);

				if (data && data.status && (data.status.ER_ADMIN_NOTLOGGEDIN || data.status.ER_AUTH)) {
					that.loginform();
					// Add updates back to queue
					if (that._submitting) {
						if (!that._submit) that._submit = {};
						for (let k in that._submitting) {
							if (typeof (that._submit[k]) === 'undefined') that._submit[k] = that._submitting[k];
						}
					}
					if (that._submittingfile) {
						if (!that._submitfile) that._submitfile = {};
						for (let k in that._submittingfile) {
							if (typeof (that._submitfile[k]) === 'undefined') that._submitfile[k] = that._submittingfile[k];
						}
					}
					if (that._submittingcallback) {
						if (!that._submitcallback) that._submitcallback = [];
						while (that._submittingcallback.length > 0) {
							that._submitcallback.unshift(that._submittingcallback.pop());
						}
					}
					if (!that._submitreload) that._submitreload = that._submittingreload;
					delete (that._submitting);
					delete (that._submittingfile);
					delete (that._submittingreload);
					delete (that._submittingcallback);
					status();
					return;
				}

				for (let key in data.global) {
					that.trigger('globalVar', key, data.global[key]);
				}

				// Fetch unloaded elements
				// Trigger metadata / variable events for all
				for (let incomingKey in data.e) {
					let element = that.elementIndexKey[incomingKey];
					if (!element) {
						let _elementId = data.e[incomingKey]._id;
						element = that.elementIndexId[_elementId];
						if (!element) {
							that.fetchElement(_elementId, function () {
								element = that.elementIndexId[_elementId];
								if (element) {
									for (let variableKey in data.m[incomingKey]) {
										that.trigger('localVar', element.key, variableKey, data.m[incomingKey][variableKey])
										element.trigger('localVar', variableKey, data.m[incomingKey][variableKey]);
									}
								}
							});
						}
					}
				}
				
				let newInserts = data.global._add;
				let newRemovals = data.global._remove;
				let newRelations = data.global._relate;
				let newUnrelations = data.global._relate;
				for (let relation of newRelations || []) {
					that.fetchElement(relation.root);
					that.fetchElement(relation.leaf);
				}
				for (let relation of newUnrelations || []) {
					that.fetchElement(relation.root);
					that.fetchElement(relation.leaf);
				}

				//Peeky.debug( JSON.stringify(data) )
				for (let incomingKey in data.e) {
					let element = that.elementIndexKey[incomingKey];
					if (!element) {
						let _elementId = data.e[incomingKey]._id;
						element = that.elementIndexId[_elementId];
					}
					if (!element) {
						continue;
					}
					let key = element.key;

					for (let parameter in data.e[incomingKey]) {
						// ONLY set data() unless data has not been updated since last
						if (parameter === '_properties') {
							//properties = JSON.parse(data.e[key][parameter]);
							let properties = data.e[incomingKey][parameter];
							for (let property in properties) {
								if (that._submit && that._submit[key + '.property.' + property]) {
									continue;
								}
								else if (element.property(property) !== properties[property]) {
									element.property(property, properties[property], false);
									element.updateUI('property.' + property);
								}
							}
						} else {
							if (that._submit && that._submit[key + '.insert.' + parameter] != undefined) {
								continue;
							}
							let currentValue = element.data(parameter);
							let returnedValue = data.e[incomingKey][parameter];
							if (currentValue !== returnedValue) {
								element.data(parameter, data.e[incomingKey][parameter], false);
								element.updateUI('insert.' + parameter);
							}
						}
					}
				}

				for (let incomingKey in data.m) {
					let element = that.elementIndexKey[incomingKey];
					if (!element) {
						let _elementId = data.m[incomingKey]._id;
						element = that.elementIndexId[_elementId];
					}
					if (element) {
						for (let variableKey in data.m[incomingKey]) {
							that.trigger('localVar', element.key, variableKey, data.m[incomingKey][variableKey])
							element.trigger('localVar', variableKey, data.m[incomingKey][variableKey]);
						}
					}
				}

				if (data.status && data.status['ER_USER_EMPTYPASSWORD']) {
					pkalert('You have to enter a password');
				} else if (data.status && data.status['ER_USER_CURRENTPASSWORD']) {
					pkalert('Authentication failed. Wrong password given.');
				} else if (data.status && data.status.ER_CHARGE) {
					pkalert(
						'We were unable to process your payment. Do you have a valid credit card added to your account?<br><br>' +
						'Contact <a href="mailto:contact@peeky.com">contact@peeky.com</a> for questions.'
					);
				} else if (data.status && data.status.ER_IMAGE_NO_DATA) {
					pkalert('We were unable to process your image. Is it saved correctly?');
					removeElementList(data.status.ER_IMAGE_NO_DATA);
				} else if (data.status && data.status.ER_IMAGE_EXTENSION_NOT_SUPPORTED) {
					pkalert('You tried to upload an unsupported image file format.');
					removeElementList(data.status.ER_IMAGE_EXTENSION_NOT_SUPPORTED);
				}

				function removeElementList(list) {
					$.each(list, function (i, key) {
						var element = that.elementIndexKey[key];
						var parent = element.parent;
						var parentParam = element.parentParam;
						if (element) {
							element.unrelate(undefined, element.parent);
							if (parent._singleDummy && parent._singleDummy[parentParam]) {
								parent._singleDummy = undefined;
							}
							parent.updateUI('related.' + parentParam);
						}
					});
				}

				// Update "body" element
				if (that._submittingreload && !that._submitreload) {
					that.currentForm.activateUrl(0, { reload: 'bdy', ipkReload: 'all', ajax: { type: 'post' } }); // Use POST to avoid IE caching
				}

				// Call callbacks
				for (let i = 0; i < that._submittingcallback.length; i++) {
					that._submittingcallback.pop().call(that);
				}

				// Submit things that might have been added since previous submit
				delete (that._submitting);
				delete (that._submittingfile);
				delete (that._submittingreload);
				delete (that._submittingcallback);

				status();

				that.submit();
			})(); // maybeRecurse

			return;
		}

		if (!this._submit) this._submit = {};
		if (!this._submitfile) this._submitfile = {};
		if (!this._submitcallback) this._submitcallback = [];
		if (typeof (this._submitreload) === 'undefined') this._submitreload = false;

		// Plain string values can be submitted as-is
		if (typeof (value) === 'string') this._submit[param] = value;
		// Null should be converted to empty string
		else if (value === null) this._submit[param] = '';

		// This should be a file input, we need to handle (submit) this separately
		else if (value instanceof jQuery && $(value).is(':file')) {
			this._submit[param] = value;
		}
		else if (value instanceof File) {
			this._submit[param] = value;
		}

		// This is an element that will be converted into an _id on submit
		else if (typeof (value) === 'object' && value.data) {
			// Check if we're allowed to update object, if not we need to clone it
			this._submit[param] = value;
		}

		else if (window.File && value instanceof window.File) {
			this._submitfile[param] = value;
		}

		if (reload) this._submitreload = true;

		if (typeof (callback) === 'function') this._submitcallback.push(callback);

		// Submit immediately, or after 300ms
		if (immediate) {
			window.setTimeout(function () {
				that.submit();
			}, 0);
		} else {
			if (this._submittimer) {
				clearTimeout(this._submittimer);
			}
			this._submittimer = window.setTimeout(function () {
				this._submittimer = undefined;
				that.submit();
			}, 300);
		}
	}


	async updateCard($form?) {
		let cardElement = $form.data('card');
		let $checkbox = $form.find('#acceptTerms');
		console.log('Update card');

		if (!$checkbox.is(':checked')) {
			return;
		}

		if ($form.is('.submitting')) {
			return;
		}

		$form.addClass('submitting');

		// Generate a Stripe setup intent
		this.root.property('stripeSetupIntent', 'true');
		await new Promise<void>((resolve) => {
			this.on('elementPropertyChange', function checkProperty(elementKey, key) {
				if (key === 'stripeSetupIntentSecret') {
					this.off('elementPropertyChange', checkProperty);
					resolve();
				}
			});
		});

		// Add card
		const clientSecret = this.root.property('stripeSetupIntentSecret');
		const setupIntent = this.root.property('stripeSetupIntent');
		const stripe: Stripe = this.$container.data('stripe');
		let result = await stripe.confirmCardSetup(
			clientSecret.toString(), {
				payment_method: {
					card: cardElement,
					billing_details: {
						email: this.root.property('billingaddress') || this.root.data('email')
					}
				}
			}
		);
		if (result.error) {
			// Display error.message in UI.
			pkalert(result.error.message);
		} else {
			// The SetupIntent was successful!
			this.root.property('stripePaymentMethod', result.setupIntent.payment_method);
			this.root.property('stripeSetupIntent', 'false');
			this.one('elementPropertyChange', function checkProperty(elementKey, key) {
				if (key === 'stripeCcLastfour') {
					this.root.updateUI();
					cardElement.clear();
				} else {
					this.one('elementPropertyChange', checkProperty);
				}
			});
			await new Promise<void>((resolve) => {
				this.one('elementPropertyChange', function () {
					resolve();
				});
			});
		}

		$form.removeClass('submitting');
	}


	queueTrigger(event, object) {
		object = object || this;
		if (typeof (object) !== 'object' || !object.trigger || !event) {
			return;
		}
		var triggerQueue = object._triggerQueue = object._triggerQueue || {};
		var animationFrame = triggerQueue[event];
		if (!animationFrame) {
			triggerQueue[event] = requestAnimationFrame(function () {
				object.trigger(event);
				if (Object.keys(triggerQueue).length <= 1) {
					delete object._triggerQueue;
				} else {
					delete triggerQueue[event];
				}
			});
		}
	}


	cloneSite(sitekey, sourceHost = 'peeky.com', protocol = 'https') {
		let that = this;
		$.ajax({
			dataType: 'jsonp',
			url: protocol + '://' + sourceHost + '/_datagraph/',
			type: 'POST',
			data: {
				'_kk.rootEntity': 'site',
				'_kk.rootId': sitekey,
				'_kk.maxDepth': 10
			},
			success: function (json) {
				$.each(json, function (i, element) {
					if (element.properties && element.properties._vimeo) {
						delete (element.data._filename);
						delete (element.properties._savedThumb);
					}
					else if (element.entity === 'file' && element.data._filename) {
						element.data._filename = protocol + '://' + sourceHost + '/_file/' + element.data._filename + '.' + element.data._extension;
					}
					else if (element.entity === 'image' && element.data._filename) {
						element.data._filename = protocol + '://' + sourceHost + '/_image/' + element.data._filename + '.' + element.data._extension;
					}
					else if (element.entity === 'graphic' && element.data._filename) {
						element.data._filename = protocol + '://' + sourceHost + '/_graphic/' + element.data._filename + '.' + element.data._extension;
					}
				});
				that.addSite(sitekey, json);
			},
			error: function () {
			}
		});
	}


	importSite(elements) {
		this.addSite('import', elements);
	}


	async loginform() {
		let $overlay = $('.loginrequired');
		let overlay = $overlay[0];

		overlay.style.opacity = '0';
		overlay.classList.remove('hidden');
		await requestAnimationFramePromise(2);
		overlay.style.opacity = '1';
		await transitionend(overlay);
		overlay.style.opacity = '';

		async function remove() {
			overlay.style.opacity = '0';
			await transitionend(overlay);
			overlay.classList.add('hidden');
			overlay.style.opacity = '';
			pk.off('loggedin', remove);
			pk.off('postGoTo', remove);
		};
		pk.one('loggedin', remove);
		pk.one('postGoTo', remove);
	}


	emailform(address) {

		// There is already an alert, don't show again
		if ($('.overlay.alert.global').length > 0) return;

		let $overlay = $(
			'<div class="overlay alert global">' +
			'<div class="bg"></div>' +
			'<div class="table"><div class="cell">' +
			'<div class="alertContent">' +
			'<div class="alertHeader">Wrong e-mail address?</div>' +
			'<div class="message">' +
			'<p>The e-mail we sent to "' + address + '" could not be delivered. Is the address spelled correctly?</p>' +
			'<p>In order to access your account at a later time, you have to provide a valid e-mail address.</p>' +
			'</div>' +
			'<input type="email" name="_changemail.insert.email" class="email text" placeholder="E-mail">' + "\n" +
			'<button class="submit">Verify your email address</button>' +
			'</div>' +
			'</div></div>' +
			'</div>'
		);
		$('body').append($overlay);
		$overlay.fadeIn(200);

		let $email = $overlay.find('.email');
		let $button = $overlay.find('button');
		let editor = this;

		$button.on('click', function () {
			editor.submit(editor.root.key + '._id', editor.root);
			editor.submit(editor.root.key + '.entity', editor.root.entity);
			editor.submit(editor.root.key + '.insert.email', $email.val().toString());
			$overlay.fadeOut(150, function () {
				$overlay.remove();
			});
		});
	}


	clean() {
		// Index elements by number of incoming master relations

		var that = this;
		var index = {};
		var array = [];

		(function iterateElements(elementNo, callback) {
			if (elementNo >= that._graph.length) {
				return callback();
			}
			var element = that._graph[elementNo];
			function iterateRelations(relationNo, callback) {
				if (relationNo >= element.relations.length) {
					return callback();
				}
				var relation = element.relations[relationNo];
				if (!index[relation._id]) {
					index[relation._id] = {
						_id: relation._id,
						master: 0,
						nonMaster: 0
					};
					array.push(index[relation._id]);
				}
				if (relation.master > 0) {
					index[relation._id].master++;
				} else {
					index[relation._id].nonMaster++;
				}
				iterateRelations(relationNo + 1, callback);
			};

			// Fetch unfetched elements
			var needsFetch = {};
			for (let i = elementNo; i < that._graph.length; i++) {
				if (that._graph[i].fetched === false) {
					needsFetch[that._graph[i]._id] = true;
				}
			}
			var needsFetchArray = Object.keys(needsFetch);

			if (needsFetchArray.length > 0) {
				that.fetchElement(needsFetchArray, function () {
					iterateRelations(0, iterateRelationsCallback);
				});
			} else {
				iterateRelations(0, iterateRelationsCallback);
			}

			function iterateRelationsCallback() {
				iterateElements(elementNo + 1, callback);
			};
		})(0, function () {
			array.sort(function (a, b) {
				return a.master - b.master;
			});

			var orphans = [];
			for (let i = 0; i < array.length; i++) {
				if (array[i].master <= 0) {
					orphans.push(array[i]);
				}
			}

		});
	}


	status(message: string, duration?: number) {
		let $ui = $('#uiFeedback');
		let heap = this._statusHeap;
		if (!heap) {
			heap = this._statusHeap = [];
			heap.push({
				message: $ui.text()
			});
		}

		let status: statusMessage = {
			message: message,
			duration: duration,
			done: false,
			timeout: undefined,
			index: undefined
		};
		heap.push(status);
		status.index = heap.length;

		function set(message) {
			if ($ui.text() != message) {
				$ui.stop().fadeOut(200, function () {
					$ui.html(message).fadeIn(200);
				});
			} else {
				$ui.stop().html(message);
				$ui.css('opacity', '');
			}
		};

		function update(message?: string, duration?: number) {
			if (status.timeout) {
				clearTimeout(status.timeout);
			}
			if (typeof (message) === 'undefined') {
				status.done = true;
				var substatus = heap.pop();
				while (substatus && substatus.done) {
					substatus = heap.pop();
				}
				if (substatus && substatus.message) {
					heap.push(substatus);
					set(substatus.message);
				} else {
					set('');
				}
			} else {
				status.message = message;
				if (status.index >= heap.length) {
					set(message);
				}
				if (typeof (duration) !== 'undefined') {
					status.timeout = window.setTimeout(function () { update(); }, duration * 1000);
				}
			}

		}

		update(message, duration);
		return update;
	}


	progress(percent) {
		var $bar = $('#uiProgress .uiProgressBar');
		if (this._progressTimer) {
			clearTimeout(this._progressTimer);
			this._progressTimer = undefined;
		}
		if (percent >= 100) {
			this._progressTimer = window.setTimeout(function () {
				$bar.animate({
					opacity: 0
				}, 200, function () {
					$bar.css({
						width: 0,
						opacity: 1
					});
				});
			}, 5000);
		}
		$bar.stop().css({
			opacity: 1,
			width: percent + '%'
		});
	};


	progressInstance(thisUploaded = 0, thisTotal = 0) {
		this._uploadUploaded = this._uploadUploaded || 0;
		if (this._uploadTotal === this._uploadUploaded) {
			this._uploadTotal = this._uploadUploaded = 0;
		}
		this._uploadUploaded += thisUploaded;
		this._uploadTotal += thisTotal;
		let updateMeter = (uploaded, total) => {
			if (total !== thisTotal) {
				this._uploadTotal += total - thisTotal;
				thisTotal = total;
			}
			this._uploadUploaded += uploaded - thisUploaded;
			thisUploaded = uploaded;
			this.progress((this._uploadUploaded / this._uploadTotal) * 100);
		};
		return updateMeter;
	};

};



// Responsive mode switcher
$('body').on('click', '#responsiveSwitcher button', async function () {
	var $button = $(this);
	var $panel = $('#panel');
	var $bodywrap = $('#bodywrap');
	var currentMode;
	var newMode;
	var $iframe = $bodywrap.find('iframe');
	var iframe = $iframe[0];
	var iframeWindow = iframe.contentWindow ? iframe.contentWindow : iframe.contentDocument.defaultView;
	var ipk = (<any>iframeWindow).pk;

	if ($bodywrap.is('.mobile')) currentMode = 'mobile';
	else if ($bodywrap.is('.tablet')) currentMode = 'tablet';
	else currentMode = 'desktop';
	if ($button.is('.mobile')) newMode = 'mobile';
	else if ($button.is('.tablet')) newMode = 'tablet';
	else newMode = 'desktop';

	$panel.removeClass(currentMode);
	$panel.addClass(newMode);

	if (newMode === currentMode) {
		return;
	} else {
		$button.siblings('.active').removeClass('active');
		$button.addClass('active');
		$bodywrap.addClass('switchResponsiveMode');
		$bodywrap.addClass('switchResponsiveModeOut');
		$bodywrap.addClass('switchResponsiveModeOutStart');
		$bodywrap.width(); // Hack
		$(window).resize();
		$bodywrap.removeClass('switchResponsiveModeOutStart');

		await transitionend($bodywrap[0]);
		$bodywrap.addClass('switchResponsiveModeIn');
		$bodywrap.addClass('switchResponsiveModeInStart');
		$bodywrap.removeClass('switchResponsiveModeOut');
		$bodywrap.removeClass(currentMode);
		$bodywrap.addClass(newMode);
		$(iframeWindow).resize(); // Should be iframe window

		await sleep(100);
		$bodywrap.removeClass('switchResponsiveModeInStart');

		await transitionend($bodywrap[0]);
		$bodywrap.removeClass('switchResponsiveModeIn');
		$bodywrap.removeClass('switchResponsiveMode');
		if (ipk) {
			ipk.trigger('resize');
		}
	}
});



let updatePerfectScroll = async ($DOM: JQuery) => {
	for (let i=0; i<$DOM.length; i++) {
		const DOM = $DOM[i];
		const $this = $(DOM);
		let ps: any = $this.data('_ps');
		if (!ps) {
			const PerfectScrollbar = (await import(/* webpackChunkName: "perfectscrollbar" */'perfect-scrollbar')).default;
			ps = new PerfectScrollbar(DOM);
			$this.data('_ps', ps);
		} else {
			ps.update();
		}
	}
};

let setValNoFocus = function ($DOM: JQuery, value: string) {
	$DOM.each(function () {
		let $this = $(this);
		if ($this.is(':focus')) {
			// Wait for blur
			let startVal = $this.val();
			let checkValue = () => {
				setTimeout(function () {
					if ($this.val() !== startVal) {
						$this.off('blur', setVal);
					}
				}, 0);
			};
			let setVal = () => {
				$this.val(value);
				$this.trigger('valNoFocus');
			};
			$this.on('keyup', checkValue);
			$this.one('blur', () => {
				$this.off('keyup', checkValue);
			});
			$this.one('blur', setVal);
		} else {
			$this.val(value);
			requestAnimationFrame(function () {
				$this.trigger('valNoFocus');
			});
		}
	});
};


export { Editor, setValNoFocus, updatePerfectScroll };
